import { Link } from 'gatsby';
import Layout from "../../../../src/components/layout";
import SEO from "../../../../src/components/seo";
import Title from "../../../../src/components/title";
import { Icons as icons } from "../../../../src/data/assets";
import PaymentComponent from "../../../../src/components/payment-component";
import Seals from "../../../../src/components/seals";
import * as React from 'react';
export default {
  Link,
  Layout,
  SEO,
  Title,
  icons,
  PaymentComponent,
  Seals,
  React
};